import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from '../styles';
import { LoadingMedium, LoadingSmall } from '../icons';

const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    animation-name: spin;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    transform-origin: 50% 50%;

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
`;

type LoadingIndicatorProps = {
  size?: 'small' | 'medium';
  color?: string;
};

const LoadingIndicator = ({ size = 'medium', color = COLORS.primary }: LoadingIndicatorProps) => {
  switch (size) {
    case 'medium':
      return (
        <LoadingWrapper>
          <LoadingMedium color={color} />
        </LoadingWrapper>
      );
    case 'small':
      return (
        <LoadingWrapper>
          <LoadingSmall color={color} />
        </LoadingWrapper>
      );
    default:
      return (
        <LoadingWrapper>
          <LoadingMedium color={color} />
        </LoadingWrapper>
      );
  }
};

export default LoadingIndicator;
